var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96094 1.4987V2.66536C3.96094 3.95403 5.00561 4.9987 6.29427 4.9987H13.2943C14.583 4.9987 15.6276 3.95403 15.6276 2.66536V1.4987H16.7943C18.083 1.4987 19.1276 2.54337 19.1276 3.83203V16.6654C19.1276 20.5313 15.9936 23.6654 12.1276 23.6654H2.79427C1.50561 23.6654 0.460938 22.6207 0.460938 21.332V3.83203C0.460938 2.54337 1.50561 1.4987 2.79427 1.4987H3.96094ZM9.79427 14.332H6.29427C5.64994 14.332 5.1276 14.8543 5.1276 15.4987C5.1276 16.143 5.64994 16.6654 6.29427 16.6654H9.79427C10.4386 16.6654 10.9609 16.143 10.9609 15.4987C10.9609 14.8543 10.4386 14.332 9.79427 14.332ZM13.2943 9.66536H6.29427C5.64994 9.66536 5.1276 10.1877 5.1276 10.832C5.1276 11.4304 5.57799 11.9235 6.15821 11.9908L6.29427 11.9987H13.2943C13.9386 11.9987 14.4609 11.4764 14.4609 10.832C14.4609 10.1877 13.9386 9.66536 13.2943 9.66536ZM12.1276 0.332031C12.772 0.332031 13.2943 0.854371 13.2943 1.4987C13.2943 2.097 12.8439 2.59012 12.2637 2.65752L12.1276 2.66536H7.46094C6.81661 2.66536 6.29427 2.14302 6.29427 1.4987C6.29427 0.900395 6.74466 0.407274 7.32488 0.33988L7.46094 0.332031H12.1276Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderManagementIcon);
export default __webpack_public_path__ + "static/media/OrderManagementIcon.56fd092dace8f3b39a02a3bd352cacae.svg";
export { ForwardRef as ReactComponent };